export default __webpack_public_path__ + "static/media/prev.c7a145aa.svg";